// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__38ShJ","info":"Panel_info__Ocy-n","btns":"Panel_btns__zCk6p","button":"Panel_button__6LJSC"};